import { Box, Heading, Icon, Tooltip } from "@chakra-ui/react";
import { Info } from "lucide-react";
import { useSelector } from "react-redux";
import _ from "lodash";
import { Helmet } from "react-helmet";

import FilterForm from "../../../components/FilterForm";
import BranchFirstContactResolutionRateReport from "../../../components/branches/reports/realtime/BranchFirstContactResolutionRate";
import { getReportDescription } from "../../../store/helpers";
import Loader from "../../../components/loader";

const BranchFirstContactResolutionRate = ({
  showFilterForm = true,
  reportIndex = 1,
}) => {
  const { branches, branchId, organizationId, reportRange, workDay } =
    useSelector((state) => state.defaultReducer);
  let branchesClone = _.cloneDeep(branches);
  branchesClone = branchesClone
    .filter(
      (a) =>
        a.reportStatus != null &&
        Number(a.reportStatus) &&
        a.organizationId === organizationId
    )
    .filter((a) => !branchId.length || (branchId.length && a.id === branchId));
  const reportTitle = `First Contact Resolution Rate`;

  return (
    <Box>
      <Helmet>
        <title>{reportTitle}</title>
      </Helmet>
      {showFilterForm ? <FilterForm /> : <></>}
      <>
        <Heading fontSize="34px" color="#222" fontWeight="700">
          {reportTitle}
          <Tooltip.Root>
            <Tooltip.Trigger asChild>
              <Icon as={Info} w={5} h={5} ml={2} cursor="pointer" />
            </Tooltip.Trigger>
            <Tooltip.Positioner>
              <Tooltip.Content>
                {getReportDescription(reportRange).BranchFirstContactResolutionRate}
              </Tooltip.Content>
            </Tooltip.Positioner>
          </Tooltip.Root>
        </Heading>
        {_.isEmpty(workDay) ? (
          <Loader />
        ) : (
          <BranchFirstContactResolutionRateReport
            reportIndex={reportIndex}
            branches={branchesClone}
          />
        )}
      </>
    </Box>
  );
};

export default BranchFirstContactResolutionRate;
